import React from "react";
import LoginField from "../components/LoginField";
import Button from "../components/Button";

class Logincont extends React.Component {
  constructor() {
    super();
    this.state = {error: ""};
  }

  render() {
    return (<div >
      <LoginField type="text" er={this.props.er} check={this.props.check}/>
      <LoginField type="password" name="Password" id="password" placeholder="Password" size="col-sm-5 col-md-5"
                  clik={this.props.update} check={this.props.check}/>
      <div className="col-sm-3 col-md-2">
        <div className="form-btn">
          <Button name="Login" loading={this.props.loading} clas="btn btn-default" link_text="Need help?"
                  link_clas="login-link help-link" clik={this.props.update}/>
        </div>
      </div>
    </div> );
  }
}
Logincont.propTypes = {
  error: React.PropTypes.string,
  loading: React.PropTypes.bool,
  er: React.PropTypes.string,
  check: React.PropTypes.func,
  update: React.PropTypes.func
};
Logincont.defaultProps = {
  error: ""

};
export default Logincont;



/** WEBPACK FOOTER **
 ** ./src/react/mainComponents/Login.js
 **/